module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUwMi45IDg3OC45YTMyIDMyIDAgMCAwIDI5LjEtNS4ybDMtMi43IDI3MS42LTI3MS41YTMyIDMyIDAgMCAwLTQyLjItNDcuOWwtMyAyLjdMNTQ0IDc3MS42IDU0NCAxOTJhMzIgMzIgMCAwIDAtNjQgMHY1NzguOGwtMjE2LjYtMjE2LjZhMzIgMzIgMCAxIDAtNDUuMiA0NS4ybDI3MS41IDI3MS42YzIuOSAyLjkgNi4yIDUuMSA5LjcgNi42bDMuNiAxLjN6IiBmaWxsPSIjMCIgcC1pZD0iODk1Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-down-outlined.svg
// module id = 6wRq
// module chunks = 73